/* Тип денег в транзакциях менеджер - курьер, менеджер - управляющий */
export default class TransactionPaymentType {
  static get Cash () { return 'cash' } // Наличность
  static get Terminal () { return 'terminal' } // Чеки терминала
}
